import { NgModule } from '@angular/core';
import { HasRoleDirective } from '../roles/has-role.directive';
import { GrantAccessDirective } from '../roles/grant-acess.directive';
import { NumberMaskDirective } from '../roles/number-mask.directive';

@NgModule({
  declarations: [HasRoleDirective, GrantAccessDirective, NumberMaskDirective],
  exports: [HasRoleDirective, GrantAccessDirective, NumberMaskDirective]
})
export class DirectivesModule { }
